module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/Facebook.472f6a93.svg";